import React from "react";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";

const ResendMailModal = ({ resendMailForm, resendMember, setResendMailModal, submit }) => {
	return (
		<>
			<div className="modal-content">
				<p className="main-desc">초대할 팀원의 초기 비밀번호를 입력해 주세요.</p>
				<p className="sub-desc">
					팀원이 비밀번호를 잊은 경우 관리자가 직접 비밀번호를 입력해 초대 메일을 재전송할
					수 있습니다.
				</p>
				<div className="f__group-row">
					<Form useForm={resendMailForm}>
						<Input
							name="name"
							className="team-invite-name"
							placeholder={resendMember?.name}
							readonly
						/>
						<Input
							name="email"
							type="email"
							className="team-invite-mail"
							placeholder={resendMember?.id}
							readonly
						/>
						<Input
							name="password"
							type="password"
							className="team-invite-password"
							placeholder="비밀번호"
							validation={{
								required: "필수 입력 사항 입니다.",
								pattern: {
									value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/,
									message: "8~16자 영문 대소문자, 숫자, 특수문자를 사용해주세요.",
								},
							}}
						/>
					</Form>
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="gray"
					onClick={() => {
						setResendMailModal(false);
					}}
				>
					취소
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={resendMailForm.handleSubmit(submit)}
				>
					초대하기
				</button>
			</div>
		</>
	);
};

export default ResendMailModal;
